export const appConfig = {
  appName: "mesh-stretch-class",
  storagePrefix: "mesh-stretch-class",
  description:
    "Peer-to-peer mesh stretching class. Each phone's accelerometer detects movement; the room advances when everyone holds the pose still.",
  accentHex: "#c490e8",
  version: __APP_VERSION__,
  commit: __GIT_COMMIT__,
  repositoryUrl: "https://github.com/baditaflorin/mesh-stretch-class",
  pagesUrl: "https://baditaflorin.github.io/mesh-stretch-class/",
  signalingUrl:
    (import.meta.env.VITE_WEBRTC_SIGNALING as string | undefined) ?? "wss://turn.0docker.com/ws",
  turnTokenUrl:
    (import.meta.env.VITE_TURN_TOKEN_URL as string | undefined) ??
    "https://turn.0docker.com/credentials",
  paypalUrl: "https://www.paypal.com/paypalme/florinbadita",
} as const;
